import { create } from 'zustand';

const useInterviewStore = create((set, get) => ({
  // State
  interviews: [],
  upcomingInterviews: [],
  assessments: [],
  loading: false,
  error: null,

  // Actions
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Add specific actions here
}));

export default useInterviewStore;